<!-- features/partners/page/partners-list/partners-list.html -->
<ui-organism-title-logos/>
<ui-organism-main-nav [mainText]="pageTitle" />

<ui-atom-spacer />
<!-- <ui-atom-text type="medium" [text]="'partners.list.subtitle' | translate"> </ui-atom-text> -->
<ui-atom-spacer size="spacer-xxl" />

<!-- Tabs con Partners y Users -->
<div class="partners-tabs">
  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedIndexChange)="onTabChange($event)"
    class="partners-tabs__group"
  >
    <!-- Tab Partners -->
    <mat-tab>
      <ng-template matTabLabel>
        {{ 'partnersTabs.partners' | translate }}
      </ng-template>
      <div class="partners-tabs__content">
        <div class="forms-header">
          <ui-atom-text type="medium" [text]="'partners.list.actions.goTo' | translate">
          </ui-atom-text>
        </div>
        <ui-atom-global-search (search)="onGlobalSearch($event)" />
        <section class="partners-list-table">
          <ui-molecule-mat-table
            [data]="tableData"
            [columns]="tableColumns"
            [paginator]="true"
            paginationMode="server"
            [totalItems]="totalItems"
            [pageIndex]="pageIndex"
            [pageSize]="pageSize"
            [isLoading]="isLoading"
            [actions]="tableActions"
            [showClearFiltersButton]="false"
            [showGlobalSearch]="false"
            [exportFileName]="'partners'"
            [useExportColumnPicker]="true"
            (actionClick)="onTableAction($event)"
            (rowClick)="onTableRowClick($event)"
            (pageChange)="onTablePageChange($event)"
            (sortChange)="onTableSortChange($event)"
            (filterChange)="onTableFilterChange($event)"
            (exportAllDataWithColumns)="onExportAllPartners($event)"
          >
            <ui-atom-button
              type="button"
              rules="main"
              styling="filled"
              [withShadow]="true"
              [text]="'partners.list.actions.create' | translate"
              (click)="openCreatePartnerDialog()"
            >
            </ui-atom-button>
          </ui-molecule-mat-table>
        </section>
      </div>
    </mat-tab>

    <!-- Tab Forms -->
    <mat-tab>
      <ng-template matTabLabel>
        {{ 'partnersTabs.forms' | translate }}
      </ng-template>
      <div class="partners-tabs__content">
        <div class="forms-header">
          <ui-atom-text type="medium" [text]="'partnersForms.subtitle' | translate"> </ui-atom-text>
        </div>
        <ui-atom-global-search (search)="onFormsGlobalSearch($event)" />
        <section class="forms-list-table">
          <ui-molecule-mat-table
            [data]="formsData"
            [columns]="formsColumns"
            [paginator]="true"
            paginationMode="server"
            [totalItems]="formsTotalItems"
            [pageIndex]="formsPageIndex"
            [pageSize]="formsPageSize"
            [isLoading]="isLoadingForms"
            [actions]="formsActions"
            [showClearFiltersButton]="false"
            [showGlobalSearch]="false"
            [exportFileName]="'forms'"
            [useExportColumnPicker]="true"
            (actionClick)="onFormAction($event)"
            (rowClick)="onFormRowClick($event)"
            (pageChange)="onFormPageChange($event)"
            (sortChange)="onFormSortChange($event)"
            (filterChange)="onFormFilterChange($event)"
            (exportAllDataWithColumns)="onExportAllForms($event)"
          >
            <ui-atom-button
              type="button"
              rules="main"
              styling="filled"
              [withShadow]="true"
              (buttonClick)="openCreateFormDialog()"
              [text]="'partnersForms.create' | translate"
              icon="add"
            >
            </ui-atom-button>
          </ui-molecule-mat-table>
        </section>
      </div>
    </mat-tab>
    <!-- Tab Users -->
    <mat-tab>
      <ng-template matTabLabel>
        {{ 'partnersTabs.users' | translate }}
      </ng-template>
      <div class="partners-tabs__content">
        <div class="forms-header">
          <ui-atom-text type="medium" [text]="'partnersUsers.subtitle' | translate"> </ui-atom-text>
        </div>
        <ui-atom-global-search (search)="onUserGlobalSearch($event)" />
        <section id="users-table" class="users-list-table">
          <ui-molecule-mat-table
            [data]="usersData"
            [columns]="userColumns"
            [paginator]="true"
            paginationMode="server"
            [totalItems]="userTotalItems"
            [pageIndex]="userPageIndex"
            [pageSize]="userPageSize"
            [isLoading]="isLoadingUsers"
            [actions]="userActions"
            [showClearFiltersButton]="false"
            [showGlobalSearch]="false"
            [exportFileName]="'users'"
            (actionClick)="onUserAction($event)"
            (pageChange)="onUserPageChange($event)"
            (sortChange)="onUserSortChange($event)"
            (exportAllData)="onExportAllUsers()"
          >
            <ui-atom-button
              type="button"
              rules="main"
              styling="filled"
              (click)="openCreateUserDialog()"
              [text]="'partnersUsers.create' | translate"
            >
            </ui-atom-button>
          </ui-molecule-mat-table>
        </section>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
